import BeneficiarySyncEntity from '../entities/BeneficiarySyncEntity';
import NumberUtils from '../../js/utils/NumberUtils';
import { sortBy, map, isEmpty } from 'lodash';

export default class BeneficiarySyncParser {
  parseBeneficiarySyncListResponse(response) {
    const _payeelist = [];
    response.beneficiaries.map((payee) => {
      const benObject = new BeneficiarySyncEntity();
      benObject.id = payee.id;
      benObject.name = payee.to_account.name;
      benObject.nickname = payee.display_name;
      benObject.sortCode = payee.to_account.sort_code;
      benObject.accountNumber = payee.to_account.account_number;
      benObject.accountNoForDisplay = `${NumberUtils.formatSortCode(
        benObject.sortCode
      )}|${benObject.accountNumber}`;
      benObject.reference = isEmpty(payee.reference)
        ? 'Reference'
        : payee.reference;
      benObject.posted = true;
      benObject.isSelected = false;
      benObject.copDetails = payee.confirmation_of_payee;
      _payeelist.push(benObject);
      return true;
    });
    return sortBy(_payeelist, ['name']);
  }

  getBeneficiariesToSync(data) {
    const _payeelist = [];
    map(data, (rowData) => {
      if (rowData.isSelected) _payeelist.push(rowData);
    });
    return _payeelist;
  }
}
